export default __webpack_public_path__ + "static/media/course-lock.8abaad3a.png";